<template lang="pug">
  div(class="container")
    v-row(v-if="slider").px-4
      v-flex(xs12 md8 lg8)
        v-slider(label="Time Scale:" v-model="tick" :tick-labels="timescale" :max="years-1" step="1" ticks="always" tick-size="6" @click="replot").pr-4
      v-flex(xs12 md4 lg4)
        v-slider(label="Duration:" v-model="duration" thumb-label="always" :max="maxDuration" :min="1" @click="replot")
   
    bar-chart(v-if="loaded" :chartdata="chartdata" :options="options" :componentkey="componentkey")
    
    div(class="text-center" v-if="!loaded").mt-12
      v-progress-circular(indeterminate class="mb-2" :size="50" :width="5" color="primary")
    
</template>

<script>
import BarChart from "../BarChart";
import moment from "moment";

export default {
  name: "FireIncidentByMonth",
  props: ["slider", "groupby", "duration", "startyear"],
  components: { BarChart },
  data: () => ({
    loaded: false,
    chartdata: Object,
    options: Object,
    years: 4,
    timescale: [],
    tick: Number,
    componentkey: 0,
    maxDuration: 60
  }),
  async mounted() {
    this.timescale = this.slider
      ? [...Array(this.years).keys()].map(() => --this.startyear + 1).sort()
      : [];
    this.tick = this.timescale.length - 1;
    this.getData()
      .then(this.sortData)
      .then(this.plotData);
  },
  methods: {
    replot() {
      this.maxDuration = (this.tick + 1) * 12;
      this.getData()
        .then(this.sortData)
        .then(this.plotData);
    },
    getData() {
      return new Promise(resolve => {
        fetch(
          `https://datahub-v2.arlingtonva.us/api/fire/IncidentLogByMonth?$skip=${Math.abs(
            this.tick - this.timescale.length + 1
          ) * this.duration}&$top=${this.duration}&$orderby=monthdate desc`
        ).then(response => {
          resolve(response.json());
        });
      });
    },

    sortData(data) {
      return Object.values(data).sort(function(a, b) {
        return new Date(a.monthdate) - new Date(b.monthdate);
      });
    },

    plotData(data) {
      this.chartdata = {
        //Data to be represented on x-axis
        labels: [...data.map(d => moment.utc(d.monthdate).format("MMM YYYY"))],
        datasets: [
          {
            label: "Fire Incidents",
            borderColor: "#f87979",
            pointBackgroundColor: "white",
            //backgroundColor: "#f87979",
            borderWidth: 3,
            pointBorderColor: "#249EBF",
            fill: false,
            //Data to be represented on y-axis
            data: [...data.map(d => d.incidentCount)]
          }
        ]
      };

      this.options = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true,
                labelString: "Incidents"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true,
                labelString: "Period"
              }
            }
          ]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      };
      this.componentkey += 1;
      this.loaded = true;
    }
  },

  computed: {},
  watch: {}
};
</script>